import { memo } from 'react';

import { type IconComponent } from '@air/design-icons';
import { IconButton, type IconButtonProps } from '@air/primitive-icon-button';

export type MobileAssetModalNavigationItemProps = Pick<IconButtonProps, 'label' | 'onClick'> & {
  id: string;
  isActive?: boolean;
} & { adsIcon: true; icon: IconComponent };

export const MobileAssetModalNavigationItem = memo(
  ({ id, isActive, label, onClick, ...iconProps }: MobileAssetModalNavigationItemProps) => {
    return (
      <IconButton
        {...iconProps}
        appearance={isActive ? 'filled' : 'ghost'}
        color="gray"
        data-testid="MOBILE_ASSET_MODAL_NAVIGATION_ITEM"
        data-navigation-id={id}
        label={label}
        onClick={onClick}
        size="large"
      />
    );
  },
);

MobileAssetModalNavigationItem.displayName = 'MobileAssetModalNavigationItem';
